import { Button, Typography } from '@material-ui/core';
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { ls } from 'shared/utils/ls';
import { useStyles } from './ErrorHandlerPage.styles';

const ErrorHandlerPage = (props) => {
  const classes = useStyles();
  const { getLS, removeLS } = ls();
  const history = useHistory();

  useEffect(() => {
    if (props.location.pathname === ROUTES.SERVER_ERROR && getLS('is_sentry_crash_report_enable')) {
      removeLS('is_sentry_crash_report_enable');
    }
  }, [props.location.pathname]);

  const renderContent = useCallback(() => {
    if (props.location.pathname === ROUTES.SERVER_ERROR) {
      return (
        <>
          <Typography variant="h4">We're currently experiencing some issues.</Typography>
          <Typography variant="body1">
            Our team has been alerted and will address the issue as soon as possible.
          </Typography>
          <div style={{ padding: '0px 20px', width: '100%' }}>
            <Button variant="outlined" size="small" onClick={() => history.push(ROUTES.TALENT.DASHBOARD)}>
              Go Back to Dashboard
            </Button>
          </div>
        </>
      );
    }
    return (
      <>
        <Typography variant="h4">404 page.</Typography>
        <Typography variant="body1">This page does not exist.</Typography>
      </>
    );
  }, [props.location.pathname]);

  return (
    <div className={classes.bodyContainer}>
      <div className={classes.bgSvg}>
        <img src="/casting-logo.png" alt="File Logo" style={{ transform: 'translateX(100px)' }} />
        <Typography>{props.location.pathname === ROUTES.SERVER_ERROR ? '#500' : '#404'}</Typography>
        <img src="/casting-logo.png" alt="File Logo" style={{ transform: 'translateX(-120px)' }} />
      </div>
      <div className={classes.errorContainer}>
        <img src="/casting-logo.png" alt="File Logo" style={{ height: '100px' }} />
        {renderContent()}
      </div>
    </div>
  );
};

export default ErrorHandlerPage;
